import { CheckoutFeature } from './checkout-feature.enum';

export type CheckoutFeatures = Partial<Record<CheckoutFeature, boolean>>;
